import React from 'react';
import './BlogCta.css';

const BlogCta = ({ category }) => {
  let ctaText = "Ready to transform your business?";
  let buttonText = "Contact Our Experts";
  let buttonLink = "/contact-us";

  // Optional: Customize CTA based on blog category
  if (category === 'SAP Consulting') {
    ctaText = "Ready to discuss your SAP landscape?";
    buttonText = "Speak to an SAP Consultant";
  } else if (category === 'AI/ML') {
    ctaText = "Ready to leverage the power of AI?";
    buttonText = "Explore AI/ML Solutions";
    buttonLink = "/ai-and-ml-consulting-services";
  }

  return (
    <div className="blog-cta-container">
      <h3>{ctaText}</h3>
      <p>Let NeuroverseAI help you navigate your digital transformation journey.</p>
      <a href={buttonLink} className="blog-cta-button">{buttonText}</a>
    </div>
  );
};

export default BlogCta;
